import { useContext } from 'react';
import { CurrentToastContext, ToastsContext } from './ToastContext.mjs';

function useToast() {
  const context = useContext(ToastsContext);
  if (!context) {
    throw new Error("ToastProvider \uC548\uCABD\uC5D0\uC11C \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694");
  }
  return context;
}
function useCurrentToast() {
  const context = useContext(CurrentToastContext);
  if (!context) {
    throw new Error("ToastProvider \uC548\uCABD\uC5D0\uC11C \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694");
  }
  return context;
}

export { useCurrentToast, useToast };
//# sourceMappingURL=useToastContext.mjs.map
